import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import {
  getNumeros, addNumero, deleteNumero, toggleNumero, updateNumero, getStats,
  getNumerosBolsa, addNumeroBolsa, deleteNumeroBolsa, toggleNumeroBolsa, updateNumeroBolsa, getStatsBolsa,
  getNumerosBolsaFamilia, addNumeroBolsaFamilia, deleteNumeroBolsaFamilia, toggleNumeroBolsaFamilia, updateNumeroBolsaFamilia, getStatsBolsaFamilia,
  getNumerosRenegociacao, addNumeroRenegociacao, deleteNumeroRenegociacao, toggleNumeroRenegociacao, updateNumeroRenegociacao, getStatsRenegociacao,
  getNumerosInss, addNumeroInss, deleteNumeroInss, toggleNumeroInss, updateNumeroInss, getStatsInss,
  getActivityLog, getDashboardStats,
  getMe, getUsuarios, addUsuario, updateUsuarioRole, deleteUsuario,
  getHealthStatus, getRealtimeChart,
  getRotasParceiros, addRotaParceiro, updateRotaParceiro, deleteRotaParceiro,
} from './api';
import { supabase } from './supabaseClient';
import './App.css';

// ── Config por produto ──
const PRODUTOS = {
  fgts: {
    nome: 'CLT & FGTS',
    path: '/fgts',
    emoji: '💼',
    desc: 'Gerenciador de números ativos — CLT & FGTS',
    apiGet: getNumeros,
    apiAdd: addNumero,
    apiDel: deleteNumero,
    apiToggle: toggleNumero,
    apiUpdate: updateNumero,
    apiStats: getStats,
    testPath: '/api/fgts',
    numerosPath: '/api/numeros',
  },
  inss: {
    nome: 'INSS',
    path: '/inss',
    emoji: '🏛️',
    desc: 'Gerenciador de números ativos — INSS',
    apiGet: getNumerosInss,
    apiAdd: addNumeroInss,
    apiDel: deleteNumeroInss,
    apiToggle: toggleNumeroInss,
    apiUpdate: updateNumeroInss,
    apiStats: getStatsInss,
    testPath: '/api/inss',
    numerosPath: '/api/numeros-inss',
  },
  bolsa: {
    nome: 'Randomizador Jeffinho',
    path: '/bolsa',
    emoji: '🎯',
    desc: 'Gerenciador de números ativos — Randomizador Jeffinho',
    apiGet: getNumerosBolsa,
    apiAdd: addNumeroBolsa,
    apiDel: deleteNumeroBolsa,
    apiToggle: toggleNumeroBolsa,
    apiUpdate: updateNumeroBolsa,
    apiStats: getStatsBolsa,
    testPath: '/api/bolsa',
    numerosPath: '/api/numeros-bolsa',
  },
  'bolsa-familia': {
    nome: 'Bolsa Família',
    path: '/bolsa-familia',
    emoji: '👨‍👩‍👧‍👦',
    desc: 'Gerenciador de números ativos — Bolsa Família',
    apiGet: getNumerosBolsaFamilia,
    apiAdd: addNumeroBolsaFamilia,
    apiDel: deleteNumeroBolsaFamilia,
    apiToggle: toggleNumeroBolsaFamilia,
    apiUpdate: updateNumeroBolsaFamilia,
    apiStats: getStatsBolsaFamilia,
    testPath: '/api/bolsa-familia',
    numerosPath: '/api/numeros-bolsa-familia',
  },
  renegociacao: {
    nome: 'Renegociacao',
    path: '/renegociacao',
    emoji: '↻',
    desc: 'Gerenciador de numeros ativos - Renegociacao',
    apiGet: getNumerosRenegociacao,
    apiAdd: addNumeroRenegociacao,
    apiDel: deleteNumeroRenegociacao,
    apiToggle: toggleNumeroRenegociacao,
    apiUpdate: updateNumeroRenegociacao,
    apiStats: getStatsRenegociacao,
    testPath: '/api/renegociacao',
    numerosPath: '/api/numeros-renegociacao',
  },
};

// ── Traduzir erros do Supabase ──
function traduzirErro(msg) {
  const map = {
    'Invalid login credentials': 'Email ou senha incorretos.',
    'Email not confirmed': 'Email não confirmado. Verifique sua caixa de entrada.',
    'User not found': 'Usuário não encontrado.',
    'Invalid email or password': 'Email ou senha inválidos.',
    'Too many requests': 'Muitas tentativas. Aguarde um momento.',
    'Network request failed': 'Erro de conexão. Verifique sua internet.',
  };
  return map[msg] || msg;
}

// ── Formatar número para exibição ──
function formatarNumero(num) {
  const limpo = num.replace(/\D/g, '');
  if (limpo.length === 11) {
    return `(${limpo.slice(0, 2)}) ${limpo.slice(2, 7)}-${limpo.slice(7)}`;
  }
  if (limpo.length === 10) {
    return `(${limpo.slice(0, 2)}) ${limpo.slice(2, 6)}-${limpo.slice(6)}`;
  }
  return num;
}

// ── SVG Copy Icon ──
const CopyIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

function App() {
  // ── Auth State ──
  const [session, setSession] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);

  // ── Produto selecionado (null = tela de seleção) ──
  const [produto, setProduto] = useState(null);
  const [dashboardStats, setDashboardStats] = useState({});

  // ── Admin State ──
  const [numeros, setNumeros] = useState([]);
  const [input, setInput] = useState('');
  const [inputColaborador, setInputColaborador] = useState('');
  const [vendedorFiltro, setVendedorFiltro] = useState(null);
  const [editingColabId, setEditingColabId] = useState(null);
  const [editingColabValue, setEditingColabValue] = useState('');
  const [ordenacao, setOrdenacao] = useState('padrao');
  const [stats, setStats] = useState(null);
  const [copied, setCopied] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [toast, setToast] = useState(null);
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [copiedNumero, setCopiedNumero] = useState(null);
  const [copiedSms, setCopiedSms] = useState(null);
  const [activityLog, setActivityLog] = useState([]);
  const [logOpen, setLogOpen] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [agoText, setAgoText] = useState('');
  const [pendingToggleIds, setPendingToggleIds] = useState(new Set());
  // Busca/Filtro (#4)
  const [searchTerm, setSearchTerm] = useState('');
  // Notificações/Health (#5)
  const [healthAlerts, setHealthAlerts] = useState(null);
  const [healthDismissed, setHealthDismissed] = useState(false);
  // Gráfico tempo real (#6)
  const [realtimeData, setRealtimeData] = useState(null);
  // Aba ativa: painel / monitoramento (#7)
  const [activeTab, setActiveTab] = useState('painel');
  // Tooltip do gráfico tempo real
  const [hoveredBar, setHoveredBar] = useState(null);
  // Role do usuário
  const [userRole, setUserRole] = useState(null);
  // Painel de usuários (admin)
  const [usuarios, setUsuarios] = useState([]);
  const [showUsuarios, setShowUsuarios] = useState(false);
  const [novoUsuarioEmail, setNovoUsuarioEmail] = useState('');
  const [novoUsuarioSenha, setNovoUsuarioSenha] = useState('');
  const [novoUsuarioRole, setNovoUsuarioRole] = useState('operador');
  // Estado de Navegação da Aplicação ('produtos', 'rotas')
  const [paginaAtual, setPaginaAtual] = useState('produtos');
  const [showNovaRotaModal, setShowNovaRotaModal] = useState(false);
  const [rotaEmEdicaoId, setRotaEmEdicaoId] = useState(null);
  const [rotas, setRotas] = useState([]);
  const [novaRotaParceiro, setNovaRotaParceiro] = useState('');
  const [novaRotaOrigem, setNovaRotaOrigem] = useState('');
  const [novaRotaProduto, setNovaRotaProduto] = useState('fgts');
  const [novaRotaTemplate, setNovaRotaTemplate] = useState('{origem} Olá, vim através do Instagram da Novo Horizonte e quero saber mais sobre o Consignado.');
  const [templateEditadoManualmente, setTemplateEditadoManualmente] = useState(false);
  // Filtros de Rotas
  const [rotasSearch, setRotasSearch] = useState('');
  const [rotasFiltroProduto, setRotasFiltroProduto] = useState('todos');
  // Filtro por período
  const hoje = new Date().toISOString().split('T')[0];
  const [filtroInicio, setFiltroInicio] = useState(() => {
    const d = new Date(); d.setDate(d.getDate() - 6);
    return d.toISOString().split('T')[0];
  });
  const [filtroFim, setFiltroFim] = useState(hoje);
  const inputRef = useRef(null);
  const toastTimeout = useRef(null);
  const produtoRef = useRef(produto);
  produtoRef.current = produto;

  const config = produto ? PRODUTOS[produto] : null;
  const redirectUrl = config ? window.location.origin + config.path : '';
  const numerosAtivos = numeros.filter(n => n.ativo !== false).length;

  // ── Dark Mode ──
  useEffect(() => {
    document.body.className = darkMode ? 'dark' : 'light';
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  // ── Toast ──
  const showToast = (message, type = 'success') => {
    if (toastTimeout.current) clearTimeout(toastTimeout.current);
    setToast({ message, type });
    toastTimeout.current = setTimeout(() => setToast(null), 3000);
  };

  // ── Copiar número ──
  const handleCopyNumero = (numero) => {
    navigator.clipboard.writeText(numero).then(() => {
      setCopiedNumero(numero);
      showToast(`Número ${formatarNumero(numero)} copiado!`);
      setTimeout(() => setCopiedNumero(null), 2000);
    });
  };

  // ── Auth ──
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session: s } }) => {
      setSession(s);
      setAuthLoading(false);
      if (s) getMe(s.access_token).then(me => setUserRole(me.role)).catch(() => setUserRole('admin'));
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, s) => {
      setSession(s);
      if (s) getMe(s.access_token).then(me => setUserRole(me.role)).catch(() => setUserRole('admin'));
      else setUserRole(null);
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    setLoginLoading(true);
    const { error } = await supabase.auth.signInWithPassword({
      email: loginEmail,
      password: loginPassword,
    });
    if (error) setLoginError(traduzirErro(error.message));
    setLoginLoading(false);
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setProduto(null);
    setUserRole(null);
  };

  const getAccessToken = () => session?.access_token || '';

  // ── Fetch dashboard stats (tela de seleção de produto) ──
  useEffect(() => {
    if (!session || produto) return;
    const fetchDashboard = async () => {
      try {
        const data = await getDashboardStats(session.access_token);
        setDashboardStats(data);
      } catch (err) {
        console.error('Dashboard stats error:', err);
      }
    };
    fetchDashboard();
    const interval = setInterval(fetchDashboard, 120000); // 2min (era 60s com 4 calls)
    return () => clearInterval(interval);
  }, [session, produto]);

  // ── Fetch data (reage a produto e session) ──
  const fetchData = useCallback(async () => {
    if (!session || !config) return;
    const fetchProduto = produto; // captura o produto no momento da chamada
    try {
      const token = session.access_token;
      const [nums, st, logs] = await Promise.all([
        config.apiGet(token),
        config.apiStats(token, filtroInicio, filtroFim),
        getActivityLog(token, produto),
      ]);
      // Descarta resultado se o produto mudou durante o fetch
      if (produtoRef.current !== fetchProduto) return;
      setNumeros(nums);
      setStats(st);
      setActivityLog(logs || []);
      setLastUpdated(new Date());
    } catch (err) {
      if (produtoRef.current === fetchProduto) console.error(err);
    }
  }, [session, config, produto, filtroInicio, filtroFim]);

  // ── Polling adaptativo ──
  const getPollingInterval = () => {
    const hora = new Date().getHours();
    return (hora >= 8 && hora < 20) ? 60000 : 180000; // 60s horário comercial, 3min fora
  };

  useEffect(() => {
    if (!session || !config) return;
    fetchData();
    let interval = setInterval(fetchData, getPollingInterval());

    // Reajusta intervalo a cada 5 min (caso mude de período)
    const recalc = setInterval(() => {
      clearInterval(interval);
      interval = setInterval(fetchData, getPollingInterval());
    }, 300000);

    // Pausar quando aba perde foco, retomar ao voltar
    const handleVisibility = () => {
      if (document.hidden) {
        clearInterval(interval);
      } else {
        fetchData(); // atualiza imediatamente
        interval = setInterval(fetchData, getPollingInterval());
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      clearInterval(interval);
      clearInterval(recalc);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [fetchData, session, config]);

  // ── Atualizar texto "há X seg" ──
  useEffect(() => {
    if (!lastUpdated) return;
    const tick = () => {
      const diff = Math.floor((Date.now() - lastUpdated.getTime()) / 1000);
      if (diff < 5) setAgoText('agora');
      else if (diff < 60) setAgoText(`há ${diff}s`);
      else setAgoText(`há ${Math.floor(diff / 60)}min`);
    };
    tick();
    const id = setInterval(tick, 5000);
    return () => clearInterval(id);
  }, [lastUpdated]);

  // ── Helpers de permissão ──
  const canEdit = userRole === 'admin' || userRole === 'operador';
  const isAdmin = userRole === 'admin';

  // ── Health Status polling (cada 5 min) (#5) ──
  useEffect(() => {
    if (!session || !config) return;
    const fetchHealth = async () => {
      try {
        const data = await getHealthStatus(session.access_token);
        setHealthAlerts(data);
        setHealthDismissed(false);
      } catch (err) {
        console.error('Health status error:', err);
      }
    };
    fetchHealth();
    const interval = setInterval(fetchHealth, 300000); // 5 min
    return () => clearInterval(interval);
  }, [session, config]);

  // ── Realtime Chart polling (cada 60s, só na aba monitoramento) (#6) ──
  useEffect(() => {
    if (!session || !config || activeTab !== 'monitoramento') return;
    const fetchRealtime = async () => {
      try {
        const data = await getRealtimeChart(session.access_token);
        setRealtimeData(data);
      } catch (err) {
        console.error('Realtime chart error:', err);
      }
    };
    fetchRealtime();
    const interval = setInterval(fetchRealtime, 60000);
    return () => clearInterval(interval);
  }, [session, config, activeTab]);

  // ── Usuários (admin) ──
  const fetchUsuarios = useCallback(async () => {
    if (!session || !isAdmin) return;
    try {
      const data = await getUsuarios(session.access_token);
      setUsuarios(data);
    } catch (err) {
      console.error('Erro ao buscar usuários:', err);
    }
  }, [session, isAdmin]);

  useEffect(() => {
    if (showUsuarios) fetchUsuarios();
  }, [showUsuarios, fetchUsuarios]);

  const handleAddUsuario = async () => {
    if (!novoUsuarioEmail.trim()) return;
    try {
      const result = await addUsuario(novoUsuarioEmail.trim(), novoUsuarioRole, novoUsuarioSenha.trim() || undefined, session.access_token);
      setNovoUsuarioEmail('');
      setNovoUsuarioSenha('');
      setNovoUsuarioRole('operador');
      if (result.senhaTemporaria) {
        showToast(`Usuário criado! Senha: ${result.senhaTemporaria}`);
      } else {
        showToast('Usuário adicionado!');
      }
      fetchUsuarios();
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  const handleChangeRole = async (id, newRole) => {
    try {
      await updateUsuarioRole(id, newRole, session.access_token);
      showToast('Role atualizada!');
      fetchUsuarios();
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  const handleDeleteUsuario = async (id) => {
    try {
      await deleteUsuario(id, session.access_token);
      showToast('Usuário removido.');
      fetchUsuarios();
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  // ── Rotas de Parceiros ──
  const fetchRotas = useCallback(async () => {
    if (!session) return;
    try {
      const data = await getRotasParceiros(session.access_token);
      setRotas(data || []);
    } catch (err) {
      console.error('Erro ao buscar rotas:', err);
    }
  }, [session]);

  useEffect(() => {
    if (paginaAtual === 'rotas') fetchRotas();
  }, [paginaAtual, fetchRotas]);

  // ── Opções de Produtos para Rotas de Parceiros ──
  const PRODUTOS_ROTAS = {
    fgts: {
      nome: 'FGTS',
      labelMensagem: 'o Crédito FGTS',
      randomizadorKey: 'fgts',
      randomizadorNome: 'CLT & FGTS',
      randomizadorEmoji: '💼',
    },
    clt: {
      nome: 'CLT',
      labelMensagem: 'o Crédito do Trabalhador',
      randomizadorKey: 'fgts',
      randomizadorNome: 'CLT & FGTS',
      randomizadorEmoji: '💼',
    },
    'garantia-veicular': {
      nome: 'Garantia Veicular',
      labelMensagem: 'o Crédito com Garantia Veicular',
      randomizadorKey: 'fgts',
      randomizadorNome: 'CLT & FGTS',
      randomizadorEmoji: '💼',
    },
    inss: {
      nome: 'INSS',
      labelMensagem: 'o Empréstimo Consignado INSS',
      randomizadorKey: 'inss',
      randomizadorNome: 'INSS',
      randomizadorEmoji: '🏛️',
    },
    'bolsa-familia': {
      nome: 'Bolsa Família',
      labelMensagem: 'o Crédito Bolsa Família',
      randomizadorKey: 'bolsa-familia',
      randomizadorNome: 'Bolsa Família',
      randomizadorEmoji: '👨‍👩‍👧‍👦',
    },
    bolsa: {
      nome: 'Randomizador Jeffinho',
      labelMensagem: 'o Crédito Jeffinho',
      randomizadorKey: 'bolsa',
      randomizadorNome: 'Jeffinho',
      randomizadorEmoji: '🎯',
    },
    renegociacao: {
      nome: 'Renegociação',
      labelMensagem: 'o Crédito para Renegociação',
      randomizadorKey: 'renegociacao',
      randomizadorNome: 'Renegociação',
      randomizadorEmoji: '↻',
    },
  };

  const gerarMensagemPadrao = (parceiro, prodKey, origem) => {
    const nomeParceiro = parceiro?.trim() ? parceiro.trim() : '{parceiro}';
    const codigoOrigem = origem?.trim() ? `(${origem.trim()})` : '({origem})';
    const prodInfo = PRODUTOS_ROTAS[prodKey];
    const produtoTexto = prodInfo ? prodInfo.labelMensagem : 'o produto';
    return `${codigoOrigem} Olá, vim através do ${nomeParceiro} e quero saber mais sobre ${produtoTexto}.`;
  };

  const handleAbrirNovaRota = () => {
    setRotaEmEdicaoId(null);
    setNovaRotaParceiro('');
    setNovaRotaOrigem('');
    setNovaRotaProduto('fgts');
    setTemplateEditadoManualmente(false);
    setNovaRotaTemplate(gerarMensagemPadrao('', 'fgts', ''));
    setShowNovaRotaModal(true);
  };

  const handleEditarRota = (r) => {
    setRotaEmEdicaoId(r.id);
    setNovaRotaParceiro(r.nome_parceiro);
    setNovaRotaOrigem(r.codigo_origem);
    setNovaRotaProduto(r.produto);
    setTemplateEditadoManualmente(true);
    setNovaRotaTemplate(r.mensagem_template || gerarMensagemPadrao(r.nome_parceiro, r.produto, r.codigo_origem));
    setShowNovaRotaModal(true);
  };

  const handleMudarParceiroModal = (val) => {
    setNovaRotaParceiro(val);
    if (!templateEditadoManualmente) {
      setNovaRotaTemplate(gerarMensagemPadrao(val, novaRotaProduto, novaRotaOrigem));
    }
  };

  const handleMudarOrigemModal = (val) => {
    setNovaRotaOrigem(val);
    if (!templateEditadoManualmente) {
      setNovaRotaTemplate(gerarMensagemPadrao(novaRotaParceiro, novaRotaProduto, val));
    }
  };

  const handleMudarProdutoModal = (prodKey) => {
    setNovaRotaProduto(prodKey);
    if (!templateEditadoManualmente) {
      setNovaRotaTemplate(gerarMensagemPadrao(novaRotaParceiro, prodKey, novaRotaOrigem));
    }
  };

  const handleAddOrUpdateRota = async () => {
    if (!novaRotaParceiro.trim() || !novaRotaOrigem.trim()) {
      showToast('Nome do parceiro e código de origem são obrigatórios.', 'error');
      return;
    }
    try {
      const payload = {
        nome_parceiro: novaRotaParceiro,
        codigo_origem: novaRotaOrigem,
        produto: novaRotaProduto,
        mensagem_template: novaRotaTemplate
      };

      if (rotaEmEdicaoId) {
        await updateRotaParceiro(rotaEmEdicaoId, payload, session.access_token);
        showToast('Rota atualizada com sucesso!');
      } else {
        await addRotaParceiro(payload, session.access_token);
        showToast('Rota de parceiro criada com sucesso!');
      }

      setNovaRotaParceiro('');
      setNovaRotaOrigem('');
      setRotaEmEdicaoId(null);
      setShowNovaRotaModal(false);
      fetchRotas();
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  const handleToggleRota = async (id, ativoAtual) => {
    try {
      await updateRotaParceiro(id, { ativo: !ativoAtual }, session.access_token);
      showToast(!ativoAtual ? 'Rota ativada!' : 'Rota pausada.');
      fetchRotas();
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  const handleDeleteRota = async (id) => {
    try {
      await deleteRotaParceiro(id, session.access_token);
      showToast('Rota removida.');
      fetchRotas();
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  // Limpar dados ao trocar de produto
  const handleSelectProduto = (key) => {
    setNumeros([]);
    setStats(null);
    setActivityLog([]);
    setInput('');
    setCopied(false);
    setConfirmDelete(null);
    setSearchTerm('');
    setHealthAlerts(null);
    setHealthDismissed(false);
    setRealtimeData(null);
    setActiveTab('painel');
    setProduto(key);
  };

  const handleVoltar = () => {
    setProduto(null);
    setNumeros([]);
    setStats(null);
    setActivityLog([]);
    setShowUsuarios(false);
    setSearchTerm('');
    setHealthAlerts(null);
    setRealtimeData(null);
    setActiveTab('painel');
    setInputColaborador('');
    setVendedorFiltro(null);
    setEditingColabId(null);
    setEditingColabValue('');
    setOrdenacao('padrao');
  };

  const handleAdd = async () => {
    const value = input.trim();
    if (!value || !config) return;
    const colabValue = inputColaborador.trim();
    try {
      await config.apiAdd(value, getAccessToken(), colabValue || null);
      setInput('');
      setInputColaborador('');
      showToast(`Número ${formatarNumero(value)} adicionado!`);
      fetchData();
      inputRef.current?.focus();
    } catch (err) {
      showToast('Erro ao adicionar número.', 'error');
      console.error(err);
    }
  };

  const handleStartEditColaborador = (id, colaboradorAtual) => {
    setEditingColabId(id);
    setEditingColabValue(colaboradorAtual || '');
  };

  const handleSaveColaborador = async (id) => {
    if (!config) return;
    const novoColaborador = editingColabValue.trim();
    try {
      setNumeros(prev => prev.map(n => n.id === id ? { ...n, colaborador: novoColaborador || null } : n));
      setEditingColabId(null);

      await config.apiUpdate(id, { colaborador: novoColaborador || null }, getAccessToken());
      showToast(
        novoColaborador
          ? `Vendedor alterado para ${novoColaborador}!`
          : 'Vendedor desvinculado do número.',
        'success'
      );
      fetchData();
    } catch (err) {
      showToast('Erro ao atualizar colaborador.', 'error');
      console.error(err);
      fetchData();
    }
  };

  const handleDelete = async (id, numero) => {
    if (!config) return;
    try {
      await config.apiDel(id, getAccessToken());
      showToast(`Número ${formatarNumero(numero)} removido.`, 'error');
      setConfirmDelete(null);
      fetchData();
    } catch (err) {
      showToast('Erro ao remover número.', 'error');
      console.error(err);
    }
  };

  const handleToggle = async (id, numero, ativoAtual) => {
    if (!config) return;
    const novoStatus = !ativoAtual;
    setPendingToggleIds(prev => new Set(prev).add(id));
    setNumeros(prev => prev.map(n => n.id === id ? { ...n, ativo: novoStatus } : n));

    try {
      const atualizado = await config.apiToggle(id, novoStatus, getAccessToken());
      if (atualizado) {
        setNumeros(prev => prev.map(n => n.id === id ? { ...n, ...atualizado } : n));
      }
      showToast(
        novoStatus
          ? `Numero ${formatarNumero(numero)} ativado!`
          : `Numero ${formatarNumero(numero)} pausado.`,
        novoStatus ? 'success' : 'error'
      );
    } catch (err) {
      setNumeros(prev => prev.map(n => n.id === id ? { ...n, ativo: ativoAtual } : n));
      showToast('Erro ao alterar status.', 'error');
      console.error(err);
    } finally {
      setPendingToggleIds(prev => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(redirectUrl).then(() => {
      setCopied(true);
      showToast('Link copiado!');
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleCopySmsLink = (key, url) => {
    navigator.clipboard.writeText(url).then(() => {
      setCopiedSms(key);
      showToast('Link copiado!');
      setTimeout(() => setCopiedSms(null), 2000);
    });
  };

  // Links SMS para disparo
  // Links extras de disparo (aparecem junto ao link principal)
  const extraDisparoLinks = {
    fgts: [
      { key: 'bc06', label: 'WhatsApp CLT (bc06)', path: '/clt', domain: 'https://clt.nhcred.com' },
      { key: 's9', label: 'Simular CLT (s9)', path: '/simular-clt' },
      { key: 'cj3', label: 'Jeffinho CLT (cj3)', path: '/jclt', domain: 'https://clt.canaldojefinho.com' },
      { key: 'cj2', label: 'Jeffinho TikTok (cj2)', path: '/jtiktok', domain: 'https://canaldojefinhot.com' },
      { key: 'di1', label: 'Disparo Interno FGTS (di1)', path: '/disparointerno', domain: 'https://disparo.nhpfgts.com' },
    ],
    'bolsa-familia': [
      { key: 'b07', label: 'WhatsApp Bolsa Família (b07)', path: '/bf', domain: 'https://whats.nhpbolsa.com' },
      { key: 'b09', label: 'WhatsApp Bolsa CP (b09)', path: '/cp', domain: 'https://cp.nhpbolsa.com' },
    ],
  };

  const smsLinks = {
    fgts: [
      { key: 'sf1', label: 'SMS FGTS (sf1)', path: '/sms-fgts', domain: 'https://sms.nhpfgts.com' },
      { key: 'sc1', label: 'SMS CLT (sc1)', path: '/sms-clt', domain: 'https://sms.nhpfgts.com' },
    ],
    'bolsa-familia': [
      { key: 'sb1', label: 'SMS Bolsa (sb1)', path: '/sms-bolsa', domain: 'https://sms.nhpbolsa.com' },
    ],
  };

  const linksPorProduto = {
    fgts: [
      { key: 'b05', label: 'FGTS principal', tipo: 'Principal', codigo: 'b05', path: '/fgts' },
      { key: 'di1', label: 'Disparo interno FGTS', tipo: 'Interno', codigo: 'di1', path: '', domain: 'https://disparo.nhpfgts.com' },
      { key: 'bc06', label: 'WhatsApp CLT', tipo: 'WhatsApp', codigo: 'bc06', path: '/clt', domain: 'https://clt.nhcred.com' },
      { key: 's9', label: 'Simular CLT', tipo: 'WhatsApp', codigo: 's9', path: '/simular-clt' },
      { key: 'f02', label: 'WhatsApp FGTS F02 Janela 24H', tipo: 'WhatsApp', codigo: 'f02', path: '/f02' },
      { key: 'b01', label: 'Disparo Sergio (b01)', tipo: 'Disparo Sergio', codigo: 'b01', path: '/b01' },
      { key: 'sf1', label: 'SMS FGTS', tipo: 'SMS', codigo: 'sf1', path: '/sms-fgts', domain: 'https://sms.nhpfgts.com' },
      { key: 'sc1', label: 'SMS CLT', tipo: 'SMS', codigo: 'sc1', path: '/sms-clt', domain: 'https://sms.nhpfgts.com' },
    ],
    bolsa: [
      { key: 'cj1', label: 'Randomizador Jeffinho', tipo: 'Principal', codigo: 'cj1', path: '/bolsa' },
      { key: 'cj3', label: 'Jeffinho CLT', tipo: 'Canal do Jefinho', codigo: 'cj3', path: '', domain: 'https://clt.canaldojefinho.com' },
      { key: 'cj2', label: 'Jeffinho TikTok', tipo: 'Canal do Jefinho', codigo: 'cj2', path: '', domain: 'https://canaldojefinhot.com' },
    ],
    'bolsa-familia': [
      { key: 'bf1', label: 'Bolsa Familia principal', tipo: 'Principal', codigo: 'bf1', path: '/bolsa-familia' },
      { key: 'parceiros-bf', label: 'Parceiros Bolsa Família', tipo: 'Parceiros LP', codigo: 'LP', path: '/bolsa-familia' },
      { key: 'b07', label: 'WhatsApp Bolsa Familia', tipo: 'WhatsApp', codigo: 'b07', path: '', domain: 'https://whats.nhpbolsa.com' },
      { key: 'b09', label: 'WhatsApp Bolsa CP', tipo: 'WhatsApp', codigo: 'b09', path: '', domain: 'https://cp.nhpbolsa.com' },
      { key: 'b10', label: 'WhatsApp Refinanciamento', tipo: 'WhatsApp', codigo: 'b10', path: '', domain: 'https://refin.nhpbolsa.com' },
      { key: 'b02', label: 'WhatsApp Bolsa B02 Janela 24H', tipo: 'WhatsApp', codigo: 'b02', path: '/b02' },
      { key: 'b03', label: 'Disparo Sergio (b03)', tipo: 'Disparo Sergio', codigo: 'b03', path: '/b03' },
      { key: 'sb1', label: 'SMS Bolsa', tipo: 'SMS', codigo: 'sb1', path: '/sms-bolsa', domain: 'https://sms.nhpbolsa.com' },
    ],
    renegociacao: [
      { key: 'b11', label: 'Renegociacao', tipo: 'Principal', codigo: 'b11', path: '', domain: 'https://reneg.nhpbolsa.com' },
    ],
    inss: [
      { key: 'inss1', label: 'INSS Principal', tipo: 'Principal', codigo: 'inss1', path: '/inss' },
    ],
  };

  const getLinkUrl = (link) => (link.domain || window.location.origin) + link.path;
  const linksProdutoAtual = linksPorProduto[produto] || [];

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleAdd();
  };

  const getNumeroStats = (numero) => {
    if (!stats?.porNumero) return { total: 0, uniqueIps: 0 };
    const found = stats.porNumero.find(s => s.numero === numero);
    return found ? { total: found.total, uniqueIps: found.uniqueIps || 0 } : { total: 0, uniqueIps: 0 };
  };

  const getMaxCliques = () => {
    if (!stats?.porNumero || stats.porNumero.length === 0) return 1;
    return Math.max(...stats.porNumero.map(s => s.total), 1);
  };

  // ── Helper comparativo (#3) ──
  const getComparativo = (atual, anterior) => {
    if (!anterior || anterior === 0) return null;
    const diff = ((atual - anterior) / anterior) * 100;
    return { diff: Math.round(diff), up: diff >= 0 };
  };

  // ── Lista de colaboradores existentes para o autocomplete ──
  const colaboradoresExistentes = useMemo(() => {
    return Array.from(
      new Set(
        numeros
          .map(n => n.colaborador)
          .filter(c => typeof c === 'string' && c.trim().length > 0)
      )
    ).sort((a, b) => a.localeCompare(b));
  }, [numeros]);

  // ── Resumo agrupado por vendedor / colaborador ──
  const resumoVendedores = useMemo(() => {
    const mapa = {};
    numeros.forEach(n => {
      const nome = (n.colaborador && n.colaborador.trim()) ? n.colaborador.trim() : 'Sem colaborador';
      if (!mapa[nome]) {
        mapa[nome] = {
          nome,
          isSemColaborador: !n.colaborador || !n.colaborador.trim(),
          total: 0,
          ativos: 0,
          pausados: 0,
          leads: 0,
          uniqueIps: 0,
        };
      }
      mapa[nome].total += 1;
      if (n.ativo !== false) {
        mapa[nome].ativos += 1;
      } else {
        mapa[nome].pausados += 1;
      }
      const st = getNumeroStats(n.numero);
      mapa[nome].leads += (st.total || 0);
      mapa[nome].uniqueIps += (st.uniqueIps || 0);
    });

    return Object.values(mapa).sort((a, b) => {
      if (a.isSemColaborador) return 1;
      if (b.isSemColaborador) return -1;
      return b.leads - a.leads || a.nome.localeCompare(b.nome);
    });
  }, [numeros, stats]);

  // ── Filtrar e ordenar números por busca, vendedor e leads ──
  const numerosFiltrados = useMemo(() => {
    return numeros.filter((n) => {
      if (vendedorFiltro) {
        if (vendedorFiltro === 'Sem colaborador') {
          if (n.colaborador && n.colaborador.trim()) return false;
        } else {
          if (!n.colaborador || n.colaborador.trim().toLowerCase() !== vendedorFiltro.toLowerCase()) return false;
        }
      }

      if (!searchTerm.trim()) return true;
      const termo = searchTerm.toLowerCase();
      const termoLimpo = termo.replace(/\D/g, '');
      const numLimpo = n.numero.replace(/\D/g, '');
      const bateuNum = (termoLimpo && numLimpo.includes(termoLimpo)) || formatarNumero(n.numero).toLowerCase().includes(termo);
      const bateuColab = n.colaborador && n.colaborador.toLowerCase().includes(termo);
      return bateuNum || bateuColab;
    }).sort((a, b) => {
      if (ordenacao === 'leads_desc') {
        const stA = getNumeroStats(a.numero).total || 0;
        const stB = getNumeroStats(b.numero).total || 0;
        return stB - stA;
      }
      if (ordenacao === 'vendedor') {
        const colA = a.colaborador || 'zzz';
        const colB = b.colaborador || 'zzz';
        return colA.localeCompare(colB);
      }
      return a.id - b.id;
    });
  }, [numeros, vendedorFiltro, searchTerm, ordenacao, stats]);

  // ── Exportar CSV ──
  const exportCSV = () => {
    if (!stats || numeros.length === 0) return;
    const sep = ';';
    const linhas = [];
    linhas.push(`Relatório ${config.nome}`);
    linhas.push(`Período: ${filtroInicio} até ${filtroFim}`);
    linhas.push(`Total cliques/leads: ${stats.redirectsHoje ?? 0}`);
    linhas.push(`IPs únicos: ${stats.uniqueHoje ?? 0}`);
    linhas.push('');
    linhas.push(['Número', 'Colaborador / Vendedor', 'Leads Recebidos', 'IPs Únicos', 'Status'].join(sep));
    numeros.forEach((n) => {
      const st = getNumeroStats(n.numero);
      linhas.push([
        formatarNumero(n.numero),
        n.colaborador || 'Sem colaborador',
        st.total,
        st.uniqueIps,
        n.ativo !== false ? 'Ativo' : 'Pausado',
      ].join(sep));
    });
    const bom = '\uFEFF';
    const blob = new Blob([bom + linhas.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const slug = config.nome.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    a.href = url;
    a.download = `relatorio-${slug}-${filtroInicio}-a-${filtroFim}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ══════════════════════════════════════
  // RENDER
  // ══════════════════════════════════════

  // ── Loading ──
  if (authLoading) {
    return (
      <div className="page">
        <div className="login-container">
          <div className="loading-spinner"></div>
          <p style={{ textAlign: 'center', marginTop: '16px' }} className="text-muted">Carregando...</p>
        </div>
      </div>
    );
  }

  // ── Login Screen ──
  if (!session) {
    return (
      <div className="page">
        <div className="login-container">
          <div className="login-icon">🔒</div>
          <h1>Random Disparo</h1>
          <p className="subtitle">Faça login para acessar o painel</p>
          <form className="login-form" onSubmit={handleLogin}>
            <div className="input-group">
              <span className="input-icon">✉</span>
              <input type="email" placeholder="E-mail" value={loginEmail}
                onChange={(e) => setLoginEmail(e.target.value)} required autoFocus />
            </div>
            <div className="input-group">
              <span className="input-icon">🔑</span>
              <input type="password" placeholder="Senha" value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)} required />
            </div>
            {loginError && <p className="login-error">{loginError}</p>}
            <button type="submit" className="btn-login" disabled={loginLoading}>
              {loginLoading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  // ── Página Separada: Rotas de Parceiros ──
  if (paginaAtual === 'rotas') {
    return (
      <div className="page page-transition">
        {toast && (
          <div className={`toast toast-${toast.type}`}>
            <span>{toast.type === 'success' ? '✓' : '✕'}</span> {toast.message}
          </div>
        )}
        <div className="top-bar">
          <button className="btn-voltar" onClick={() => setPaginaAtual('produtos')}>
            ← Voltar para Produtos
          </button>
          <div style={{ flex: 1 }}></div>
          <button className="btn-theme" onClick={() => setDarkMode(!darkMode)}
            title={darkMode ? 'Modo claro' : 'Modo escuro'}>
            {darkMode ? '☀️' : '🌙'}
          </button>
          <span className="user-email">👤 {session.user.email}</span>
          <button className="btn-logout" onClick={handleLogout}>Sair</button>
        </div>

        <h1>🤝 Rotas de Parceiros</h1>
        <p className="subtitle" style={{ marginBottom: '20px' }}>
          Gerencie links dinâmicos e origens para influenciadores e campanhas.
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
          <button
            className="btn-rotas-parceiros"
            onClick={handleAbrirNovaRota}
          >
            + Criar Rota de Parceiro
          </button>
        </div>

        {/* Modal de Criação / Edição de Rota */}
        {showNovaRotaModal && (
          <div className="modal-overlay" onClick={() => setShowNovaRotaModal(false)}>
            <div className="modal" style={{ maxWidth: '540px', width: '92%', textAlign: 'left' }} onClick={(e) => e.stopPropagation()}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0, color: 'var(--accent)', fontSize: '1.2rem' }}>
                  🤝 {rotaEmEdicaoId ? 'Editar Rota de Parceiro' : 'Nova Rota de Parceiro'}
                </h3>
                <button className="btn-close-usuarios" onClick={() => setShowNovaRotaModal(false)}>✕</button>
              </div>

              <div className="usuario-add-form" style={{ flexDirection: 'column', gap: '14px', alignItems: 'stretch' }}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <div style={{ flex: 2, minWidth: '160px' }}>
                    <label style={{ fontSize: '12px', opacity: 0.8, display: 'block', marginBottom: '4px', textAlign: 'left' }}>Parceiro:</label>
                    <input
                      type="text"
                      placeholder="Ex: João Silva"
                      value={novaRotaParceiro}
                      onChange={(e) => handleMudarParceiroModal(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </div>

                  <div style={{ flex: 1, minWidth: '90px' }}>
                    <label style={{ fontSize: '12px', opacity: 0.8, display: 'block', marginBottom: '4px', textAlign: 'left' }}>Origem:</label>
                    <input
                      type="text"
                      placeholder="Ex: i8"
                      value={novaRotaOrigem}
                      onChange={(e) => handleMudarOrigemModal(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </div>

                  <div style={{ flex: 1.3, minWidth: '150px' }}>
                    <label style={{ fontSize: '12px', opacity: 0.8, display: 'block', marginBottom: '4px', textAlign: 'left' }}>Produto:</label>
                    <select
                      value={novaRotaProduto}
                      onChange={(e) => handleMudarProdutoModal(e.target.value)}
                      style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-input)', color: 'var(--text-color)' }}
                    >
                      <option value="fgts">FGTS</option>
                      <option value="clt">CLT</option>
                      <option value="garantia-veicular">Garantia Veicular</option>
                      <option value="inss">INSS</option>
                      <option value="bolsa-familia">Bolsa Família</option>
                      <option value="bolsa">Randomizador Jeffinho</option>
                      <option value="renegociacao">Renegociação</option>
                    </select>
                  </div>
                </div>

                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                    <label style={{ fontSize: '12px', opacity: 0.8, textAlign: 'left' }}>
                      Template de Mensagem do WhatsApp:
                    </label>
                    <span style={{ fontSize: '11px', color: 'var(--accent)', opacity: 0.9 }}>
                      (atualiza conforme o parceiro, origem e produto)
                    </span>
                  </div>
                  <textarea
                    rows="3"
                    value={novaRotaTemplate}
                    onChange={(e) => {
                      setTemplateEditadoManualmente(true);
                      setNovaRotaTemplate(e.target.value);
                    }}
                    placeholder="{origem} Olá, vim através do {parceiro} e quero saber mais sobre..."
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-input)', color: 'var(--text-color)', fontFamily: 'inherit' }}
                  />
                </div>

                <div className="modal-buttons" style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                  <button className="btn-cancel" onClick={() => setShowNovaRotaModal(false)}>Cancelar</button>
                  <button className="btn-add" onClick={handleAddOrUpdateRota} style={{ padding: '10px 24px' }}>
                    {rotaEmEdicaoId ? 'Salvar Alterações' : 'Criar Rota'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Barra de Pesquisa e Filtros */}
        <div className="rotas-filters-bar">
          <input
            type="text"
            className="rotas-search-input"
            placeholder="🔍 Buscar por parceiro ou código de origem..."
            value={rotasSearch}
            onChange={(e) => setRotasSearch(e.target.value)}
          />
          <select
            className="rotas-filter-select"
            value={rotasFiltroProduto}
            onChange={(e) => setRotasFiltroProduto(e.target.value)}
          >
            <option value="todos">Todos os Produtos / Randomizadores</option>
            <option value="fgts">FGTS</option>
            <option value="clt">CLT</option>
            <option value="garantia-veicular">Garantia Veicular</option>
            <option value="bolsa-familia">Bolsa Família</option>
            <option value="inss">INSS</option>
            <option value="bolsa">Randomizador Jeffinho</option>
            <option value="renegociacao">Renegociação</option>
          </select>
        </div>

        {/* Listagem Simples de Rotas em Tabela */}
        {(() => {
          const termo = rotasSearch.toLowerCase().trim();
          const rotasFiltradas = rotas.filter((r) => {
            const matchesSearch = !termo ||
              r.nome_parceiro.toLowerCase().includes(termo) ||
              r.codigo_origem.toLowerCase().includes(termo);
            const matchesFiltro = rotasFiltroProduto === 'todos' || r.produto === rotasFiltroProduto;
            return matchesSearch && matchesFiltro;
          });

          if (rotasFiltradas.length === 0) {
            return (
              <div className="rotas-card" style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--text-muted)' }}>
                <p style={{ fontSize: '1.1rem', marginBottom: '8px' }}>
                  {rotas.length === 0 ? 'Nenhuma rota cadastrada ainda.' : 'Nenhuma rota encontrada para os filtros selecionados.'}
                </p>
                {rotas.length === 0 && (
                  <p style={{ fontSize: '0.85rem' }}>Clique em <strong>"+ Criar Rota de Parceiro"</strong> para cadastrar a primeira.</p>
                )}
              </div>
            );
          }

          return (
            <div className="rotas-table-container">
              <table className="rotas-table">
                <thead>
                  <tr>
                    <th>Parceiro</th>
                    <th>Origem</th>
                    <th>Produto / Randomizador</th>
                    <th>Link da Rota</th>
                    <th style={{ textAlign: 'right' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {rotasFiltradas.map((r) => {
                    const linkFormatado = `${window.location.origin}/r/${r.produto}/${encodeURIComponent(r.nome_parceiro.toLowerCase().replace(/\s+/g, '-'))}/${r.codigo_origem}`;
                    const prodInfo = PRODUTOS_ROTAS[r.produto] || {
                      nome: r.produto.toUpperCase(),
                      randomizadorKey: r.produto,
                      randomizadorNome: r.produto,
                      randomizadorEmoji: '•',
                    };
                    const rowColorClass = `rota-row-${prodInfo.randomizadorKey}`;
                    const statusClass = !r.ativo ? 'rota-row-pausada' : '';

                    return (
                      <tr key={r.id} className={`${rowColorClass} ${statusClass}`}>
                        <td>
                          <strong style={{ color: 'var(--text-primary)' }}>{r.nome_parceiro}</strong>
                        </td>
                        <td>
                          <span style={{ fontFamily: 'Consolas, monospace', fontWeight: 'bold', color: 'var(--accent)' }}>
                            {r.codigo_origem}
                          </span>
                        </td>
                        <td>
                          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                            <span className={`badge-produto badge-${r.produto}`}>
                              {prodInfo.nome}
                            </span>
                            <span className="badge-randomizador" title="Randomizador associado">
                              {prodInfo.randomizadorEmoji} {prodInfo.randomizadorNome}
                            </span>
                          </div>
                        </td>
                        <td>
                          <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)', fontFamily: 'monospace' }}>
                            /r/{r.produto}/{r.codigo_origem}
                          </span>
                        </td>
                        <td>
                          <div className="rotas-actions-col" style={{ justifyContent: 'flex-end' }}>
                            <button
                              className="btn-icon-action"
                              onClick={() => {
                                navigator.clipboard.writeText(linkFormatado);
                                showToast('Link da rota copiado!');
                              }}
                              title="Copiar link"
                            >
                              📋 Copiar
                            </button>
                            <a
                              href={linkFormatado}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn-icon-action"
                              title="Abrir rota no navegador"
                            >
                              🔗 Abrir
                            </a>
                            <button
                              className="btn-icon-action"
                              onClick={() => handleEditarRota(r)}
                              title="Editar rota"
                            >
                              ✏️
                            </button>
                            <button
                              className="btn-icon-action"
                              onClick={() => handleToggleRota(r.id, r.ativo)}
                              title={r.ativo ? 'Pausar rota' : 'Ativar rota'}
                            >
                              {r.ativo ? '⏸️' : '▶️'}
                            </button>
                            <button
                              className="btn-icon-action danger"
                              onClick={() => handleDeleteRota(r.id)}
                              title="Remover rota"
                            >
                              🗑️
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          );
        })()}
      </div>
    );
  }

  // ── Seleção de Produto ──
  if (!produto) {
    return (
      <div className="page page-transition">
        {toast && (
          <div className={`toast toast-${toast.type}`}>
            <span>{toast.type === 'success' ? '✓' : '✕'}</span> {toast.message}
          </div>
        )}
        <div className="top-bar">
          <div style={{ flex: 1 }}></div>
          <div className="header-user-actions">
            <button className="btn-theme" onClick={() => setDarkMode(!darkMode)}
              title={darkMode ? 'Modo claro' : 'Modo escuro'}>
              {darkMode ? '☀️' : '🌙'}
            </button>
            <span className="user-email">👤 {session.user.email}</span>
            <button className="btn-logout" onClick={handleLogout}>Sair</button>
          </div>
        </div>
        <h1>Random Disparo</h1>
        <p className="subtitle" style={{ marginBottom: '14px' }}>Selecione o produto para gerenciar</p>

        {/* Ações principais centralizadas */}
        <div className="home-action-buttons" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', marginBottom: '24px', flexWrap: 'wrap' }}>
          {isAdmin && (
            <button className="btn-manage-users" onClick={() => setShowUsuarios(!showUsuarios)}>
              👥 Gerenciar Usuários
            </button>
          )}
          <button
            className="btn-rotas-parceiros"
            onClick={() => setPaginaAtual('rotas')}
          >
            🤝 Rotas de Parceiros
          </button>
        </div>

        {/* Painel de Usuários */}
        {showUsuarios && isAdmin && (
          <div className="usuarios-card">
            <div className="card-header">
              <h2>👥 Usuários</h2>
              <button className="btn-close-usuarios" onClick={() => setShowUsuarios(false)}>✕</button>
            </div>

            <div className="usuario-add-form">
              <input type="email" placeholder="Email" value={novoUsuarioEmail}
                onChange={(e) => setNovoUsuarioEmail(e.target.value)} />
              <input type="text" placeholder="Senha (opcional)" value={novoUsuarioSenha}
                onChange={(e) => setNovoUsuarioSenha(e.target.value)} />
              <select value={novoUsuarioRole} onChange={(e) => setNovoUsuarioRole(e.target.value)}>
                <option value="admin">Admin</option>
                <option value="operador">Operador</option>
                <option value="viewer">Viewer</option>
              </select>
              <button className="btn-add" onClick={handleAddUsuario}>+ Adicionar</button>
            </div>

            <div className="usuarios-list">
              {usuarios.map((u) => (
                <div key={u.id} className="usuario-item">
                  <div className="usuario-info">
                    <span className="usuario-email">{u.email}</span>
                    <span className={`usuario-role role-${u.role}`}>{u.role}</span>
                  </div>
                  <div className="usuario-actions">
                    <select value={u.role} onChange={(e) => handleChangeRole(u.id, e.target.value)}>
                      <option value="admin">Admin</option>
                      <option value="operador">Operador</option>
                      <option value="viewer">Viewer</option>
                    </select>
                    <button className="btn-remove-usuario" onClick={() => handleDeleteUsuario(u.id)}
                      title="Remover usuário">&times;</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="product-selector">
          {Object.entries(PRODUTOS).map(([key, p]) => {
            const ds = dashboardStats[key];
            return (
              <button key={key} className="product-card" onClick={() => handleSelectProduto(key)}>
                <span className="product-emoji">{p.emoji}</span>
                <div className="product-info">
                  <span className="product-name">{p.nome}</span>
                  {ds ? (
                    <div className="product-stats">
                      <span className="product-stat">
                        <span className="product-stat-value">{ds.redirectsHoje ?? 0}</span>
                        <span className="product-stat-label">cliques hoje</span>
                        {ds.redirectsOntem > 0 && (() => {
                          const cmp = getComparativo(ds.redirectsHoje, ds.redirectsOntem);
                          if (!cmp) return null;
                          return (
                            <span className={`product-stat-compare ${cmp.up ? 'compare-up' : 'compare-down'}`}>
                              {cmp.up ? '↑' : '↓'} {Math.abs(cmp.diff)}%
                            </span>
                          );
                        })()}
                      </span>
                      <span className="product-stat-divider">·</span>
                      <span className="product-stat">
                        <span className="product-stat-value">{ds.uniqueHoje ?? 0}</span>
                        <span className="product-stat-label">IPs únicos</span>
                      </span>
                      <span className="product-stat-divider">·</span>
                      <span className="product-stat">
                        <span className="product-stat-value">{ds.ativos}/{ds.totalNumeros}</span>
                        <span className="product-stat-label">números</span>
                      </span>
                    </div>
                  ) : (
                    <span className="product-stat-loading">Carregando...</span>
                  )}
                </div>
                <span className="product-arrow">→</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  // ── Admin Panel (produto selecionado) ──
  const maxCliques = getMaxCliques();

  return (
    <div className={`page-wrapper ${logOpen ? 'log-open' : ''}`}>
      {/* Side Panel - Log de Atividades */}
      <div className={`log-sidebar ${logOpen ? 'open' : ''}`}>
        <div className="log-sidebar-header">
          <h3>📋 Log de Atividades</h3>
          <button className="log-sidebar-close" onClick={() => setLogOpen(false)}>✕</button>
        </div>
        {activityLog.length === 0 ? (
          <p className="log-empty">Nenhuma atividade registrada.</p>
        ) : (
          <div className="activity-list">
            {activityLog.map((log) => {
              const acaoEmoji = { adicionou: '➕', removeu: '🗑️', pausou: '⏸️', ativou: '▶️' };
              const acaoClass = { adicionou: 'acao-add', removeu: 'acao-remove', pausou: 'acao-pause', ativou: 'acao-activate' };
              const dt = new Date(log.created_at);
              const timeStr = dt.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
              return (
                <div key={log.id} className={`activity-item ${acaoClass[log.acao] || ''}`}>
                  <span className="activity-emoji">{acaoEmoji[log.acao] || '•'}</span>
                  <div className="activity-info">
                    <span className="activity-text">
                      <strong>{log.usuario}</strong> {log.acao} <strong>{formatarNumero(log.numero)}</strong>
                    </span>
                    <span className="activity-time">{timeStr}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="page page-transition">
        {/* Botão toggle log */}
        <button className="btn-log-toggle" onClick={() => setLogOpen(!logOpen)} title="Log de Atividades">
          📋
        </button>
        {/* Toast */}
        {toast && (
          <div className={`toast toast-${toast.type}`}>
            <span>{toast.type === 'success' ? '✓' : '✕'}</span> {toast.message}
          </div>
        )}

        {/* Confirm Delete Modal */}
        {confirmDelete && (
          <div className="modal-overlay" onClick={() => setConfirmDelete(null)}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <h3>Remover número?</h3>
              <p>Tem certeza que deseja remover o número <strong>{formatarNumero(confirmDelete.numero)}</strong>?</p>
              <div className="modal-buttons">
                <button className="btn-cancel" onClick={() => setConfirmDelete(null)}>Cancelar</button>
                <button className="btn-confirm-delete" onClick={() => handleDelete(confirmDelete.id, confirmDelete.numero)}>Remover</button>
              </div>
            </div>
          </div>
        )}

        <div className="top-bar">
          <button className="btn-voltar" onClick={handleVoltar}>← Produtos</button>
          <button className="btn-theme" onClick={() => setDarkMode(!darkMode)}
            title={darkMode ? 'Modo claro' : 'Modo escuro'}>
            {darkMode ? '☀️' : '🌙'}
          </button>
          <span className="user-email">👤 {session.user.email} {userRole && <span className={`role-badge role-${userRole}`}>{userRole}</span>}</span>
          <button className="btn-logout" onClick={handleLogout}>Sair</button>
        </div>
        <h1>{config.emoji} {config.nome}</h1>
        <p className="subtitle">{config.desc}</p>
        {lastUpdated && (
          <span className="polling-indicator" title={`Última atualização: ${lastUpdated.toLocaleTimeString('pt-BR')}`}>
            🟢 Atualizado {agoText}
          </span>
        )}

        {/* Abas: Painel / Monitoramento (#7) */}
        <div className="tab-bar">
          <button className={`tab-btn ${activeTab === 'painel' ? 'tab-active' : ''}`} onClick={() => setActiveTab('painel')}>
            📊 Painel
          </button>
          <button className={`tab-btn ${activeTab === 'links' ? 'tab-active' : ''}`} onClick={() => setActiveTab('links')}>
            Links
          </button>
          <button className={`tab-btn ${activeTab === 'monitoramento' ? 'tab-active' : ''}`} onClick={() => setActiveTab('monitoramento')}>
            🔍 Monitoramento
            {healthAlerts && !healthAlerts.ok && <span className="tab-badge">!</span>}
          </button>
        </div>

        {/* Notificação de alertas (#5) */}
        {activeTab === 'painel' && healthAlerts && !healthAlerts.ok && !healthDismissed && (
          <div className="health-banner health-banner-danger">
            <div className="health-banner-content">
              <span className="health-banner-icon">🚨</span>
              <div className="health-banner-text">
                <strong>{healthAlerts.problemas.length} problema{healthAlerts.problemas.length > 1 ? 's' : ''} detectado{healthAlerts.problemas.length > 1 ? 's' : ''}</strong>
                <span className="health-banner-detail">
                  {healthAlerts.problemas.slice(0, 2).map(p => p.mensagem).join(' · ')}
                </span>
              </div>
              <button className="health-banner-action" onClick={() => setActiveTab('monitoramento')}>Ver detalhes →</button>
              <button className="health-banner-dismiss" onClick={() => setHealthDismissed(true)}>✕</button>
            </div>
          </div>
        )}
        {activeTab === 'painel' && healthAlerts && healthAlerts.ok && healthAlerts.avisos?.length > 0 && !healthDismissed && (
          <div className="health-banner health-banner-warn">
            <div className="health-banner-content">
              <span className="health-banner-icon">💡</span>
              <div className="health-banner-text">
                <strong>{healthAlerts.avisos.length} aviso{healthAlerts.avisos.length > 1 ? 's' : ''}</strong>
                <span className="health-banner-detail">
                  {healthAlerts.avisos.slice(0, 2).map(a => a.mensagem).join(' · ')}
                </span>
              </div>
              <button className="health-banner-action" onClick={() => setActiveTab('monitoramento')}>Ver →</button>
              <button className="health-banner-dismiss" onClick={() => setHealthDismissed(true)}>✕</button>
            </div>
          </div>
        )}

        {/* ═══ ABA PAINEL ═══ */}
        {activeTab === 'painel' && (
          <>
            {/* Estatísticas */}
            <div className="redirect-section">
              <div className="stats-row">
                <div className="stat-card">
                  <span className="stat-value">{stats?.totalRedirects ?? '—'}</span>
                  <span className="stat-label">Redirects total</span>
                </div>
                <div className="stat-card stat-card-highlight">
                  <span className="stat-value">{stats?.redirectsHoje ?? '—'}</span>
                  <span className="stat-label">Cliques período</span>
                  {/* Comparativo (#3) — usa historico se disponível */}
                  {(() => {
                    if (!stats?.historico || stats.historico.length < 2) return null;
                    const hojeH = stats.historico.find(h => h.isHoje);
                    const ontemH = stats.historico[stats.historico.length - 2];
                    if (!hojeH || !ontemH || ontemH.cliques === 0) return null;
                    const cmp = getComparativo(hojeH.cliques, ontemH.cliques);
                    if (!cmp) return null;
                    return (
                      <span className={`stat-compare ${cmp.up ? 'compare-up' : 'compare-down'}`}>
                        {cmp.up ? '↑' : '↓'} {Math.abs(cmp.diff)}% vs {ontemH.dia}
                      </span>
                    );
                  })()}
                </div>
                <div className="stat-card">
                  <span className="stat-value">{stats?.uniqueHoje ?? '—'}</span>
                  <span className="stat-label">IPs únicos período</span>
                  {(() => {
                    if (!stats?.historico || stats.historico.length < 2) return null;
                    const hojeH = stats.historico.find(h => h.isHoje);
                    const ontemH = stats.historico[stats.historico.length - 2];
                    if (!hojeH || !ontemH || ontemH.uniqueIps === 0) return null;
                    const cmp = getComparativo(hojeH.uniqueIps, ontemH.uniqueIps);
                    if (!cmp) return null;
                    return (
                      <span className={`stat-compare ${cmp.up ? 'compare-up' : 'compare-down'}`}>
                        {cmp.up ? '↑' : '↓'} {Math.abs(cmp.diff)}% vs {ontemH.dia}
                      </span>
                    );
                  })()}
                </div>
                <div className="stat-card">
                  <span className="stat-value">{numerosAtivos}</span>
                  <span className="stat-label">Números ativos</span>
                </div>
              </div>

              {/* Filtro por Período */}
              <div className="filtro-periodo">
                <span className="filtro-label">📅 Período:</span>
                <input type="date" value={filtroInicio} onChange={(e) => setFiltroInicio(e.target.value)} max={filtroFim} />
                <span className="filtro-sep">até</span>
                <input type="date" value={filtroFim} onChange={(e) => setFiltroFim(e.target.value)} min={filtroInicio} max={hoje} />
                <button className="btn-filtro-hoje" onClick={() => { setFiltroInicio(hoje); setFiltroFim(hoje); }}>Hoje</button>
                <button className="btn-filtro-7d" onClick={() => { const d = new Date(); d.setDate(d.getDate() - 6); setFiltroInicio(d.toISOString().split('T')[0]); setFiltroFim(hoje); }}>7 dias</button>
                <button className="btn-filtro-30d" onClick={() => { const d = new Date(); d.setDate(d.getDate() - 29); setFiltroInicio(d.toISOString().split('T')[0]); setFiltroFim(hoje); }}>30 dias</button>
                <button className="btn-export-csv" onClick={exportCSV} title="Exportar dados como CSV">⬇ Exportar CSV</button>
              </div>

              {/* Histórico do período */}
              {stats?.historico && stats.historico.length > 0 && (
                <div className="historico-section">
                  <h3 className="historico-title">📊 Histórico do Período</h3>
                  <div className="historico-legenda">
                    <span className="legenda-item"><span className="legenda-cor legenda-cliques"></span>Cliques</span>
                    <span className="legenda-item"><span className="legenda-cor legenda-ips"></span>IPs únicos</span>
                  </div>
                  <div className="historico-chart">
                    {stats.historico.map((h, i) => {
                      const maxHist = Math.max(...stats.historico.map(x => x.cliques), 1);
                      const barCliques = (h.cliques / maxHist) * 100;
                      const barIps = (h.uniqueIps / maxHist) * 100;
                      const isHoje = h.isHoje;
                      return (
                        <div key={h.data} className={`historico-bar-col ${isHoje ? 'historico-hoje' : ''}`}>
                          <div className="historico-valores">
                            <span className="historico-valor">{h.cliques}</span>
                            <span className="historico-valor historico-valor-ip">{h.uniqueIps}</span>
                          </div>
                          <div className="historico-bars-duo">
                            <div className="historico-bar-bg">
                              <div className="historico-bar-fill" style={{ height: `${barCliques}%` }}></div>
                            </div>
                            <div className="historico-bar-bg historico-bar-bg-ip">
                              <div className="historico-bar-fill-ip" style={{ height: `${barIps}%` }}></div>
                            </div>
                          </div>
                          <span className="historico-dia">{isHoje ? 'Hoje' : h.dia}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* Números e Resumo por Vendedor */}
            <div className="numbers-card">
              <div className="card-header">
                <h2>Números</h2>
                <span className="counter">{numerosAtivos} / {numeros.length} ativos</span>
              </div>

              {/* ── Resumo por Vendedor / Colaborador ── */}
              {numeros.length > 0 && (
                <div className="resumo-vendedores-section">
                  <div className="resumo-vendedores-header">
                    <div className="resumo-vendedores-title">
                      <span className="resumo-icon">👥</span>
                      <h3>Resumo por Vendedor</h3>
                      <span className="resumo-count-badge">
                        {resumoVendedores.filter(v => !v.isSemColaborador).length} cadastrado{resumoVendedores.filter(v => !v.isSemColaborador).length !== 1 ? 's' : ''}
                      </span>
                    </div>
                    {vendedorFiltro && (
                      <button
                        className="btn-clear-vendedor-filtro"
                        onClick={() => setVendedorFiltro(null)}
                        title="Ver todos os números"
                      >
                        Limpar filtro ({vendedorFiltro}) ✕
                      </button>
                    )}
                  </div>

                  <div className="vendedores-grid">
                    {resumoVendedores.map((v) => {
                      const isSelected = vendedorFiltro === v.nome;
                      return (
                        <div
                          key={v.nome}
                          className={`vendedor-card ${isSelected ? 'vendedor-card-active' : ''} ${v.isSemColaborador ? 'vendedor-card-unassigned' : ''}`}
                          onClick={() => setVendedorFiltro(isSelected ? null : v.nome)}
                          title={`Clique para filtrar números de ${v.nome}`}
                        >
                          <div className="vendedor-card-top">
                            <div className="vendedor-card-nome">
                              <span className="vendedor-avatar">{v.isSemColaborador ? '❓' : '👤'}</span>
                              <strong className="vendedor-nome-text">{v.nome}</strong>
                            </div>
                            <span className="vendedor-total-nums">{v.total} tel{v.total > 1 ? 's' : ''}</span>
                          </div>

                          <div className="vendedor-card-stats">
                            <span className="vendedor-pill vendedor-pill-ativo" title="Números ativos">
                              <span className="status-dot dot-green"></span> {v.ativos} ativo{v.ativos !== 1 ? 's' : ''}
                            </span>
                            <span className="vendedor-pill vendedor-pill-pausado" title="Números pausados">
                              <span className="status-dot dot-gray"></span> {v.pausados} pausado{v.pausados !== 1 ? 's' : ''}
                            </span>
                          </div>

                          <div className="vendedor-card-leads">
                            <span className="vendedor-leads-icon">🎯</span>
                            <span className="vendedor-leads-valor">{v.leads} leads</span>
                            <span className="vendedor-leads-unique">({v.uniqueIps} únicos)</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Barra de Busca e Ordenação */}
              {numeros.length > 0 && (
                <div className="numbers-toolbar">
                  <div className="search-numeros">
                    <span className="search-icon">🔍</span>
                    <input
                      type="text"
                      placeholder="Buscar por telefone ou colaborador..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="search-input"
                    />
                    {searchTerm && (
                      <button className="search-clear" onClick={() => setSearchTerm('')}>✕</button>
                    )}
                    {(searchTerm || vendedorFiltro) && (
                      <span className="search-count">{numerosFiltrados.length} de {numeros.length}</span>
                    )}
                  </div>

                  {numeros.length > 2 && (
                    <div className="sort-numeros">
                      <span className="sort-label">Ordenar:</span>
                      <select
                        value={ordenacao}
                        onChange={(e) => setOrdenacao(e.target.value)}
                        className="sort-select"
                      >
                        <option value="padrao">Padrão</option>
                        <option value="leads_desc">Mais leads</option>
                        <option value="vendedor">Vendedor (A-Z)</option>
                      </select>
                    </div>
                  )}
                </div>
              )}

              {/* Filtro ativo aviso */}
              {vendedorFiltro && (
                <div className="filtro-ativo-banner">
                  <span>Exibindo telefones de <strong>{vendedorFiltro}</strong> ({numerosFiltrados.length} encontrado{numerosFiltrados.length !== 1 ? 's' : ''})</span>
                  <button className="btn-remover-filtro-tag" onClick={() => setVendedorFiltro(null)}>Ver todos ✕</button>
                </div>
              )}

              {/* Alerta: números sem cliques */}
              {(() => {
                const ativos = numeros.filter(n => n.ativo !== false);
                const comCliques = ativos.filter(n => getNumeroStats(n.numero).total > 0);
                const semCliques = ativos.filter(n => getNumeroStats(n.numero).total === 0);
                if (semCliques.length === 0) return null;
                const cliquesOrdenados = comCliques.map(n => getNumeroStats(n.numero).total).sort((a, b) => a - b);
                const mediana = cliquesOrdenados.length > 0
                  ? (cliquesOrdenados.length % 2 === 0
                    ? (cliquesOrdenados[cliquesOrdenados.length / 2 - 1] + cliquesOrdenados[cliquesOrdenados.length / 2]) / 2
                    : cliquesOrdenados[Math.floor(cliquesOrdenados.length / 2)])
                  : 0;
                if (mediana < 5) return null;
                return (
                  <div className="alerta-sem-cliques">
                    <span className="alerta-icon">⚠️</span>
                    <span>{semCliques.length} número{semCliques.length > 1 ? 's' : ''} ativo{semCliques.length > 1 ? 's' : ''} sem cliques no período</span>
                  </div>
                );
              })()}

              {/* Input Area com campo de colaborador */}
              {canEdit && (
                <div className="input-area input-area-enhanced">
                  <div className="input-field-group">
                    <input
                      ref={inputRef}
                      type="text"
                      placeholder="Telefone (Ex: 48999998888)"
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={handleKeyDown}
                      className="input-num-field"
                    />
                    <input
                      type="text"
                      placeholder="Colaborador (Ex: Cindy)"
                      list="colaboradores-datalist"
                      value={inputColaborador}
                      onChange={(e) => setInputColaborador(e.target.value)}
                      onKeyDown={handleKeyDown}
                      className="input-colab-field"
                    />
                    <datalist id="colaboradores-datalist">
                      {colaboradoresExistentes.map((c) => (
                        <option key={c} value={c} />
                      ))}
                    </datalist>
                  </div>
                  <button className="btn-add" onClick={handleAdd}>+ Adicionar</button>
                </div>
              )}

              <div className="numbers-list">
                {numerosFiltrados.length === 0 && !searchTerm && !vendedorFiltro && (
                  <div className="empty-msg">Nenhum número cadastrado. Adicione acima.</div>
                )}
                {numerosFiltrados.length === 0 && (searchTerm || vendedorFiltro) && (
                  <div className="empty-msg">
                    Nenhum número encontrado
                    {searchTerm && ` para "${searchTerm}"`}
                    {vendedorFiltro && ` para o vendedor "${vendedorFiltro}"`}.
                  </div>
                )}
                {numerosFiltrados.map((n, idx) => {
                  const st = getNumeroStats(n.numero);
                  const percent = maxCliques > 0 ? (st.total / maxCliques) * 100 : 0;
                  const isAtivo = n.ativo !== false;
                  const semClique = isAtivo && st.total === 0;
                  const ativosComCliques = numeros.filter(x => x.ativo !== false && getNumeroStats(x.numero).total > 0);
                  const cliquesOrd = ativosComCliques.map(x => getNumeroStats(x.numero).total).sort((a, b) => a - b);
                  const med = cliquesOrd.length > 0
                    ? (cliquesOrd.length % 2 === 0
                      ? (cliquesOrd[cliquesOrd.length / 2 - 1] + cliquesOrd[cliquesOrd.length / 2]) / 2
                      : cliquesOrd[Math.floor(cliquesOrd.length / 2)])
                    : 0;
                  const mostrarWarn = semClique && med >= 5;
                  return (
                    <div key={n.id} className={`number-item ${!isAtivo ? 'number-item-paused' : ''} ${mostrarWarn ? 'number-item-warn' : ''}`}>
                      <span className="num-index">{idx + 1}.</span>
                      <div className="num-info">
                        <div className="num-top-row">
                          <div className="num-primary-row">
                            <span className="num-value">{formatarNumero(n.numero)}</span>
                            <button className="btn-copy-num" onClick={() => handleCopyNumero(n.numero)}
                              title="Copiar número">
                              {copiedNumero === n.numero ? '✓' : <CopyIcon size={14} />}
                            </button>

                            {/* Tag de Colaborador com Edição Inline */}
                            {editingColabId === n.id ? (
                              <div className="colab-edit-box">
                                <input
                                  type="text"
                                  autoFocus
                                  placeholder="Nome do vendedor"
                                  list="colaboradores-datalist"
                                  value={editingColabValue}
                                  onChange={(e) => setEditingColabValue(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') handleSaveColaborador(n.id);
                                    if (e.key === 'Escape') setEditingColabId(null);
                                  }}
                                  className="colab-edit-input"
                                />
                                <button className="btn-colab-save" onClick={() => handleSaveColaborador(n.id)} title="Salvar">✓</button>
                                <button className="btn-colab-cancel" onClick={() => setEditingColabId(null)} title="Cancelar">✕</button>
                              </div>
                            ) : (
                              <span
                                className={`badge-colaborador ${n.colaborador ? 'has-vendedor' : 'no-vendedor'}`}
                                onClick={() => canEdit && handleStartEditColaborador(n.id, n.colaborador)}
                                title={canEdit ? 'Clique para alterar colaborador' : 'Colaborador responsável'}
                              >
                                <span className="colab-icon">👤</span>
                                <span className="colab-text">{n.colaborador || 'Atribuir vendedor'}</span>
                                {canEdit && <span className="colab-edit-icon" title="Editar">✏️</span>}
                              </span>
                            )}
                          </div>

                          {/* Indicador Destacado de Leads Recebidos */}
                          <div className="num-leads-indicator" title={`${st.total} cliques totais e ${st.uniqueIps} pessoas únicas no período`}>
                            <span className="leads-icon">🎯</span>
                            <span className="leads-count">{st.total}</span>
                            <span className="leads-label">leads</span>
                            <span className="leads-unique">({st.uniqueIps} únicos)</span>
                          </div>

                          {mostrarWarn && <span className="num-warn-badge" title="Sem cliques no período">⚠️</span>}

                          {canEdit && (
                            <button
                              className={`btn-toggle ${isAtivo ? 'btn-toggle-on' : 'btn-toggle-off'} ${pendingToggleIds.has(n.id) ? 'btn-toggle-pending' : ''}`}
                              onClick={() => handleToggle(n.id, n.numero, isAtivo)}
                              disabled={pendingToggleIds.has(n.id)}
                              title={isAtivo ? 'Pausar número' : 'Ativar número'}>
                              <span className="toggle-track" aria-hidden="true">
                                <span className="toggle-dot"></span>
                              </span>
                              <span className="toggle-label">{isAtivo ? 'Ativo' : 'Pausado'}</span>
                            </button>
                          )}
                          {canEdit && (
                            <button className="btn-remove"
                              onClick={() => setConfirmDelete({ id: n.id, numero: n.numero })}
                              title="Remover número">&times;</button>
                          )}
                        </div>
                        <div className="num-bar-bg">
                          <div className="num-bar-fill" style={{ width: `${percent}%` }}></div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}

        {/* ABA LINKS */}
        {activeTab === 'links' && (
          <div className="links-panel">
            <div className="links-panel-header">
              <div>
                <h2>Links de Randomizacao</h2>
                <p>Todos os links criados para disparos, agrupados por produto.</p>
              </div>
              <span className="links-count">{linksProdutoAtual.length} links</span>
            </div>

            {linksProdutoAtual.length > 0 && (
              <div className="links-current">
                <h3>Produto atual</h3>
                <div className="links-grid">
                  {linksProdutoAtual.map((link) => {
                    const url = getLinkUrl(link);
                    const copyKey = `${produto}-${link.key}`;
                    return (
                      <div className="link-card" key={copyKey}>
                        <div className="link-card-top">
                          <span className="link-type">{link.tipo}</span>
                          <span className="link-code">{link.codigo}</span>
                        </div>
                        <strong>{link.label}</strong>
                        <span className="link-url">{url}</span>
                        <button className="btn-copy-main" onClick={() => handleCopySmsLink(copyKey, url)}>
                          {copiedSms === copyKey ? 'Copiado!' : <><CopyIcon size={14} /> Copiar</>}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}


          </div>
        )}

        {/* ═══ ABA MONITORAMENTO (#7) ═══ */}
        {activeTab === 'monitoramento' && (
          <div className="monitoring-section">

            {/* Hero Status Banner */}
            <div className={`monitor-hero ${healthAlerts?.ok ? 'hero-ok' : 'hero-danger'}`}>
              <div className="monitor-hero-left">
                <div className={`monitor-hero-pulse ${healthAlerts?.ok ? 'pulse-ok' : 'pulse-danger'}`}></div>
                <div>
                  <div className="monitor-hero-title">{healthAlerts?.ok ? 'Todos os sistemas operacionais' : 'Problemas detectados'}</div>
                  <div className="monitor-hero-sub">Verificado às {healthAlerts?.hora_brasilia || '--:--'} · Brasília</div>
                </div>
              </div>
              <div className="monitor-hero-stats">
                <div className="monitor-hero-stat">
                  <span className="monitor-hero-stat-val">{healthAlerts?.total_cliques_hoje ?? '—'}</span>
                  <span className="monitor-hero-stat-lbl">cliques hoje</span>
                </div>
                <div className="monitor-hero-divider"></div>
                <div className="monitor-hero-stat">
                  <span className="monitor-hero-stat-val">{healthAlerts?.total_cliques_1h ?? '—'}</span>
                  <span className="monitor-hero-stat-lbl">última hora</span>
                </div>
                <div className="monitor-hero-divider"></div>
                <div className="monitor-hero-stat">
                  <span className="monitor-hero-stat-val">
                    {healthAlerts?.numeros_ativos ? Object.values(healthAlerts.numeros_ativos).reduce((t, v) => t + Number(v || 0), 0) : '—'}
                  </span>
                  <span className="monitor-hero-stat-lbl">números ativos</span>
                </div>
              </div>
            </div>

            {/* Gráfico tempo real (#6) */}
            <div className="realtime-card">
              <div className="realtime-header">
                <div className="realtime-header-left">
                  <span className="realtime-live-badge"><span className="live-dot"></span>AO VIVO</span>
                  <h3>Cliques em Tempo Real</h3>
                </div>
                <span className="realtime-subtitle">Últimos 60 min · <strong>{realtimeData?.total ?? 0}</strong> cliques</span>
              </div>
              <div className="realtime-chart-wrap">
                {realtimeData?.minutos ? (
                  <>
                    <div className="realtime-grid-lines">
                      <div className="grid-line"></div>
                      <div className="grid-line"></div>
                      <div className="grid-line"></div>
                    </div>
                    <div className="realtime-chart">
                      {realtimeData.minutos.map((val, i) => {
                        const heightPct = realtimeData.pico > 0 ? (val / realtimeData.pico) * 100 : 0;
                        const isRecent = i >= 55;
                        const minutesAgo = 60 - i - 1;
                        const label = minutesAgo === 0 ? 'agora' : `${minutesAgo} min atrás`;
                        return (
                          <div
                            key={i}
                            className={`realtime-bar-col ${isRecent ? 'realtime-recent' : ''} ${val > 0 ? 'has-value' : ''}`}
                            onMouseEnter={() => setHoveredBar({ i, val, label })}
                            onMouseLeave={() => setHoveredBar(null)}
                          >
                            {hoveredBar?.i === i && val > 0 && (
                              <div className="bar-tooltip">
                                <span className="bar-tooltip-val">{val}</span>
                                <span className="bar-tooltip-lbl">{label}</span>
                              </div>
                            )}
                            <div className="realtime-bar-bg">
                              <div
                                className="realtime-bar-fill"
                                style={{ height: `${Math.max(heightPct, val > 0 ? 4 : 0)}%` }}
                              ></div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <div className="realtime-loading">Carregando dados...</div>
                )}
              </div>
              <div className="realtime-labels">
                <span>-60 min</span>
                <span>-45 min</span>
                <span>-30 min</span>
                <span>-15 min</span>
                <span>agora</span>
              </div>
            </div>

            {/* Alertas e Avisos */}
            {healthAlerts && (healthAlerts.problemas.length > 0 || healthAlerts.avisos.length > 0) && (
              <div className="monitoring-alerts-card">
                <h3>📋 Alertas e Avisos</h3>
                {healthAlerts.problemas.length > 0 && (
                  <div className="monitoring-alert-group">
                    <h4 className="alert-group-title alert-danger-title">🚨 Problemas ({healthAlerts.problemas.length})</h4>
                    {healthAlerts.problemas.map((p, i) => (
                      <div key={i} className="monitoring-alert-item alert-item-danger">
                        <span>{p.mensagem}</span>
                      </div>
                    ))}
                  </div>
                )}
                {healthAlerts.avisos.length > 0 && (
                  <div className="monitoring-alert-group">
                    <h4 className="alert-group-title alert-warn-title">💡 Avisos ({healthAlerts.avisos.length})</h4>
                    {healthAlerts.avisos.map((a, i) => (
                      <div key={i} className="monitoring-alert-item alert-item-warn">
                        <span>{a.mensagem}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {healthAlerts && healthAlerts.problemas.length === 0 && healthAlerts.avisos.length === 0 && (
              <div className="monitoring-alerts-card monitoring-all-clear">
                <span className="all-clear-icon">🎉</span>
                <span className="all-clear-text">Nenhum alerta ativo. Sistema funcionando normalmente!</span>
              </div>
            )}

            {/* Info Workflows n8n */}
            <div className="monitoring-workflows-card">
              <h3>🤖 Workflows n8n</h3>
              <div className="workflow-list">
                <div className="workflow-item">
                  <span className="workflow-status-dot dot-active"></span>
                  <div className="workflow-info">
                    <span className="workflow-name">📧 Relatório Diário</span>
                    <span className="workflow-detail">Envio automático por e-mail às 22h · Resumo completo do dia</span>
                  </div>
                </div>
                <div className="workflow-item">
                  <span className="workflow-status-dot dot-active"></span>
                  <div className="workflow-info">
                    <span className="workflow-name">🚨 Alertas de Problemas</span>
                    <span className="workflow-detail">Verificação a cada 2h · Envia e-mail se detectar problemas</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Atividade Recente */}
            {activityLog.length > 0 && (
              <div className="monitoring-activity-card">
                <h3>📋 Atividade Recente</h3>
                <div className="monitoring-activity-list">
                  {activityLog.slice(0, 10).map((log) => {
                    const acaoEmoji = { adicionou: '➕', removeu: '🗑️', pausou: '⏸️', ativou: '▶️' };
                    const acaoColor = { adicionou: 'activity-add', removeu: 'activity-remove', pausou: 'activity-pause', ativou: 'activity-activate' };
                    const dt = new Date(log.created_at);
                    const timeStr = dt.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
                    return (
                      <div key={log.id} className="monitoring-activity-item">
                        <div className={`activity-icon-wrap ${acaoColor[log.acao] || ''}`}>
                          <span>{acaoEmoji[log.acao] || '•'}</span>
                        </div>
                        <div className="monitoring-activity-body">
                          <span className="monitoring-activity-text">
                            <strong>{log.usuario}</strong> {log.acao} <strong>{formatarNumero(log.numero)}</strong>
                          </span>
                          <span className="monitoring-activity-time">{timeStr}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;


